import {useMutation, useQueryClient} from "@tanstack/react-query";
import {PayloadShoppingItems} from "../types/shopping";
import Api from "../api/Api";
import {QUERY_KEYS} from "./queryKeys";

export default function useAddShoppingCartItems() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: PayloadShoppingItems[]) => {
      try {
        const response = await Api.shopping.AddShoppingToCartItem(payload);

        if (response.Error !== null && response.Error !== undefined) {
          throw new Error(
            typeof response.Error === 'string'
              ? response.Error
              : response.Error?.ErrorMessage ?? 'Error add shopping to cart'
          );
        }

        return response.Result;
      } catch (error) {
        console.error("Error adding items to shopping cart", error);

        throw error;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.cart.getShoppingCart],
      });
    },
  });
}
